import React from 'react';
import PropTypes from 'prop-types';

const DownloadConsentFormLink = ({ url, text, className }) => (
  <a
    id="download-consent-form-link"
    role="link"
    className={`text-dark-grey underline text-sm ${className}`}
    target="_blank"
    href={url}
    rel="noreferrer noopener"
    download
  >
    {text}
  </a>
);

DownloadConsentFormLink.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
};

DownloadConsentFormLink.defaultProps = {
  text: 'Download Consent Form',
  className: '',
};

export default DownloadConsentFormLink;
